export function translationFieldState(sourceValue, value) {
  const normalized = (value ?? "").toString().trim()
  const source = (sourceValue ?? "").toString().trim()

  if (!normalized) return "empty"
  if (normalized === source) return "unchanged"
  return "translated"
}

export function translationProgress(name, fields, fieldValues) {
  const entries = [
    { value: name },
    ...fields.map((field) => ({ value: fieldValues[field.key] })),
  ]

  const total = entries.length
  const completed = entries.filter((entry) => (entry.value ?? "").toString().trim() !== "").length

  return {
    total,
    completed,
    percent: total === 0 ? 0 : Math.round((completed / total) * 100),
  }
}
